import type { Kennzahl, GetValuesFn } from './types'

/**
 * Baut ein einzelnes IST-Wert-Dataset aus der direkten Messung der Kennzahl.
 * Standardpfad für alle Kennzahlen ohne besondere Datenbau-Logik.
 *
 * @param kennzahl   - Kennzahl-Konfiguration
 * @param getValues  - reaktive Datenfunktion (nach Semester gefiltert & sortiert)
 * @param baseYears  - Semester-Achsenbeschriftungen
 * @param selectedType - aktuell ausgewählter Diagrammtyp (bestimmt die Farbe)
 */
export function buildSimpleChartData(
    kennzahl: Kennzahl,
    getValues: GetValuesFn,
    baseYears: string[],
    selectedType: string
): any {
    const currentValues = getValues(kennzahl.kennzahlId)

    let isPercentValue = false
    let maxValue = 0
    const data: { x: string; y: number | string }[] = []

    currentValues.forEach((v) => {
        data.push({ x: v.semester, y: v.wert })
        isPercentValue = v.percentValue
        maxValue = Math.max(maxValue, Number(v.wert))
    })

    if (!data.length) return false

    // Skalierung der Y-Achse
    if (isPercentValue && maxValue > 0.66) {
        maxValue = Math.max(maxValue, 1)
    } else if (isPercentValue && maxValue) {
        maxValue *= 1.15
    } else if (isPercentValue && !maxValue) {
        maxValue = 1
    } else if (maxValue) {
        maxValue *= 1.15
    } else {
        maxValue = 10
    }

    return {
        labels: baseYears,
        datasets: [
            {
                label: 'IST-Wert',
                data,
                backgroundColor: selectedType === 'LineChart' ? '#E53009' : '#009EE3',
                fill: false,
                maxBarThickness: 41,
                minBarLength: 7, // sorgt dafür, dass Balken auch bei Wert 0 sichtbar sind
                isPercentValue,
                maxValue
            }
        ]
    }
}
